import { defineI18nConfig } from "#imports";
import { DEFAULT_LOCALE } from "@/domain/constants";

export default defineI18nConfig(() => ({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
}));
